export function getScrollParent(node) {
  if (!node || !node.offsetParent) return false;
  let offsetParent = node;
  while ((offsetParent = offsetParent.offsetParent)) {
    const overflowYVal = window
      .getComputedStyle(offsetParent, null)
      .getPropertyValue("overflow-y");
    if (overflowYVal === "auto" || overflowYVal === "scroll")
      return offsetParent;
  }
  return window;
}
